module.exports = __webpack_public_path__ + "img/rolling_64.1d5fe10c.svg";